export default __webpack_public_path__ + "static/media/Pill.7633f59d.svg";